import { Component, inject, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Store } from "@ngrx/store";
import { Subscription, Observable, concat } from "rxjs";
import { ActionButton } from "../../../common/interfaces/global-interfaces";
import { GraphqlService } from "../../../services/graphql.service";
import { NotificationService } from "../../../services/notification.service";
import { SettingsService } from "../../../services/settings.service";
import { LayoutService } from "../../../shared/components/app-layout/shared-layout/layout.service";
import { TableConfiguration } from "../../../shared/components/paginated-data-table/paginated-table-configuration.model";
import { AppState } from "../../../store";
import { StoreItemActions } from "../../../store/entities/store-item/store-item.actions";
import { StoreItemEntity } from "../../../store/entities/store-item/store-item.model";
import { selectStoreItems } from "../../../store/entities/store-item/store-item.selectors";
import { FaqAddComponent } from "./faq-add/faq-add.component";
import {
  DELETE_FAQ_MUTATION,
  GET_ALL_FAQS_QUERY,
} from "../../../store/entities/settings/faq/faq.graphql";
import {Faq} from "../../../store/entities/settings/faq/faq.model";

@Component({
  selector: "app-faq-list",
  templateUrl: "./faq-list.component.html",
  styleUrl: "./faq-list.component.scss",
})
export class FaqListComponent implements OnInit {
  loading: boolean;
  viewDetails: boolean;
  addPermission: string[] = ["can_configure_settings"];
  viewDetailsTitle: string;
  viewType: string;
  faqsUniqueId: string;
  additionalVariables = {};
  selectedUuid: string;
  tableColumns: object;
  searchKeys = ["question"];
  routeSub = Subscription.EMPTY;
  title: string;
  faq$: Observable<Faq[]>;

  constructor(
    private settingService: SettingsService = inject(SettingsService),
    private layoutService: LayoutService,
    private activeRoute: ActivatedRoute,
    private notificationService: NotificationService,
    private store: Store<AppState>,
    private apollo: GraphqlService,
    private settingsService: SettingsService
  ) {}
  query;
  ngOnInit() {
    this.title = "Faqs List";
    this.query = GET_ALL_FAQS_QUERY;

    this.faq$ = this.store.select(
      selectStoreItems(StoreItemEntity.faqs)
    );

    this.routeSub = this.activeRoute.queryParams.subscribe((items) => {
      this.title = "Faqs List";
      this.viewDetails = !!items["action"];
      this.viewType = items["action"] ?? "";
      this.selectedUuid = items["id"] ?? "";

      this.viewDetailsTitle =
        this.viewType === "view" ? "Faqs details" : "";
    });
    this.additionalVariables = {
      faqsUniqueId: this.selectedUuid,
    };

    this.title = "Faqs List";
  }

  customAction(event: any) {
    // if (event?.action == "more") return this.onView(event?.value);
    if (event?.action == "delete") return this.onDelete(event?.value);
    if (event?.action == "edit") return this.onAdd(event?.value);
  }

  upsertAction = StoreItemActions.upsertStoreItem;
  removeAction = StoreItemActions.deleteStoreItem;

  refreshDataTable: boolean = false;
  permissions = {
    // more: ["NO_PERMISSION"],
    edit: ["can_configure_settings"],
    delete: ["can_configure_settings"],
  };

  tableConfiguration: TableConfiguration = {
    tableColumns: [
      { name: "question", label: "Question" },
      { name: "answer", label: "Answer" },
    ],
    tableCaption: "",
    showNumbers: true,
    tableNotifications: "Notification",
    showSearch: true,
    useFullObject: true,
    showBorder: true,
    allowPagination: true,
    useRowClick: true,
    actionIcons: {
      edit: false,
      delete: false,
      more: false,
      print: false,
      customPrimary: false,
    },
    doneLoading: false,
    deleting: {},
    active: {},
    hideExport: true,
    customPrimaryMessage: "Activate",
    empty_msg: "No data found",
  };

  actionButtons: ActionButton[] = [
    // {
    //   id: "more",
    //   label: "View More",
    //   title: "View More",
    //   class: "",
    //   icon: "list",
    //   action: "more",
    //   confirm_first: false,
    //   loading_message: "",
    // },
    {
      id: "edit",
      label: "Edit",
      title: "Edit",
      class: "",
      icon: "edit",
      action: "edit",
      confirm_first: false,
      loading_message: "",
    },
    {
      id: "delete",
      label: "Delete",
      title: "Delete",
      class: "",
      icon: "delete",
      action: "delete",
      confirm_first: false,
      loading_message: "",
    },
  ];

  onAdd(data = null) {
    this.settingService.openDialogModal({
      component: FaqAddComponent,
      data: data,
    });
  }

  onView(data: Faq = null) {
    this.layoutService.openPanel({ action: "view", id: data?.uniqueId });
    this.viewDetailsTitle = "View FAQs";
  }

  onDelete(faq: Faq) {
    this.notificationService
      .confirmation({ message: "Are you sure?" })
      .then(async (data) => {
        try {
          if (data) {
            this.store.dispatch(
              StoreItemActions.removeStoreItem({
                entity: StoreItemEntity.faqs,
                input: {
                  uniqueId: faq.uniqueId,
                },
                id: faq?.id,
                mutation: DELETE_FAQ_MUTATION,
              })
            );
          }
        } catch (error) {
          console.error(error);
        }
      });
  }

  closePanel(shouldUpdate = false) {
    this.layoutService.closePanel();
  }

  mapFunction(faq: Faq) {
    return {
      ...faq,
    };
  }


  protected readonly concat = concat;
}
